<template>
    <form-view class="lottery-service-form-view" @submitsuccess="goToNext">
        <veui-steps :steps="steps" :current="1"/>
        <template slot="field">
            <h3>填写基本信息</h3>
            <veui-field label="应用名称："
                name="appId"
                field="appId"
                :readonly="!!store.createForFixedAppId || isDetail"
                :disabled="isEdit"
                rules="required">
                <search-select
                    :options="store.appDatasource"
                    v-model="store.formData.appId"
                    placeholder="请选择"/>
                    <veui-button v-if="isCreate" @click="goToCreateApp" ui="link">新建应用</veui-button>
            </veui-field>
           <veui-field label="服务名称："
                name="name"
                field="name"
                :readonly="isDetail"
                :disabled="!isEditDraft && !isCreate"
                :rules="validator('required|name|maxLength:20')"
                tip="最多可输入20个字符">
                <veui-input
                    v-model="store.formData.name"
                    placeholder="数字、字母、汉字"/>
            </veui-field>
            <template v-if="isDetail">
                <veui-field label="authKey：">
                    <veui-span>{{ authKey }}</veui-span>
                </veui-field>
                <veui-field label="activityId：">
                    <veui-span>{{ activityId }}</veui-span>
                </veui-field>
            </template>
            <veui-field label="数据接收邮箱：" name="mailReceiver" field="mailReceiver" :rules="validator('multiEmail')">
                <veui-input
                    v-model="store.formData.mailReceiver"
                    placeholder="请输入邮箱，多个邮箱英文逗号分隔"/>
            </veui-field>
            <veui-field
                label="数据解压密码："
                name="zipPassword"
                field="zipPassword"
                :rules="store.formData.mailReceiver ? 'required' : ''">
                <veui-input
                    v-model="store.formData.zipPassword"/>
            </veui-field>
            <veui-field label="活动描述："
                name="description"
                field="description"
                :disabled="!isEditDraft && !isCreate"
                tip="最多可输入150个字符"
                rules="required">
                <veui-textarea
                    v-model="store.formData.description"/>
            </veui-field>
            <h3>{{ lotteryHeader }}</h3>
            <veui-field label="已添加领券奖项：" name="awards" field="awards" :rules="validator('required|notEmpty')">
                <template v-if="isCreate || isEditDraft">
                    <veui-button ui="small" @click="addAwardOpen = true">添加</veui-button>
                </template>
                <div class="award-item" v-for="(award, idx) in store.formData.awards" :key="idx">
                    <veui-span>奖项名称：{{ award.name }}</veui-span>
                    <veui-button v-if="isDetail" @click="currentAward = award">查看</veui-button>
                    <template v-else>
                        <veui-button ui="tiny" @click="currentAward = award">修改</veui-button>
                        <veui-button ui="tiny" @click="deleteAward(award)">删除</veui-button>
                    </template>
                </div>
                <veui-dialog :open.sync="addAwardOpen"
                    :title="awardDialogTitle"
                    overlay-class="add-award-dialog">
                    <add-award ref="addAward" :readonly="isDetail" v-model="currentAward"/>
                    <template slot="foot">
                        <veui-button ui="primary" @click="submitAward" v-if="!isDetail">确认</veui-button>
                        <veui-button @click="addAwardOpen = false">{{ cancelText }}</veui-button>
                    </template>
                </veui-dialog>
            </veui-field>
        </template>
        <template slot="operation">
            <template v-if="isCreate || isEditDraft">
                <veui-button ui="primary" type="submit"
                    @click="store.formData.submitType = 'publish'">发布并继续</veui-button>
                <veui-button class="primary-border-btn"
                    type="submit"
                    @click="store.formData.submitType = 'save'">保存为草稿</veui-button>
            </template>
            <veui-button v-else-if="isEdit"
                @click="store.formData.submitType = 'publish'"
                ui="primary"
                type="submit">修改完成</veui-button>
            <veui-button @click="back">{{ cancelText }}</veui-button>
        </template>
    </form-view>
</template>

<script>
import FormView from '@baidu/ve-ria/views/FormView';
import FormModel from './FormModel';
import createView from '@baidu/ve-ria/views/createView';
import {Steps, Field, Button, Input, Span, Dialog, Textarea} from 'veui';
import SearchSelect from '@/common/components/SearchSelect';
import AddAward from './AddAward';
import serviceMixin from '@/common/mixins/service';
import {get, uniqueId, findIndex} from 'lodash';
import uri from '@baidu/ve-ria/utils/uri';

export default createView(FormView, FormModel, {
    name: 'LotteryServiceFormView',
    components: {
        'veui-field': Field,
        'veui-input': Input,
        'veui-span': Span,
        'veui-button': Button,
        'veui-steps': Steps,
        'veui-dialog': Dialog,
        'veui-textarea': Textarea,
        SearchSelect,
        AddAward
    },
    mixins: [serviceMixin],
    data() {
        return {
            steps: [
                {
                    label: '填写基本信息'
                },
                {
                    label: '设置奖项券码'
                },
                {
                    label: '发布服务'
                }
            ],
            currentAward: null
        };
    },
    computed: {
        lotteryHeader() {
            return this.isCreate || this.isEditDraft ? '设置领券奖项' : '领券奖项';
        },
        awardDialogTitle() {
            return get(this.currentAward, 'id') ? '编辑奖券' : '添加奖券';
        },
        authKey() {
            return get(this.store.serviceDetail, 'authKey');
        },
        activityId() {
            return get(this.store.serviceDetail, 'activityId');
        },
        addAwardOpen: {
            get() {
                return !!this.currentAward;
            },
            set(val) {
                this.currentAward = val ? this.getEmptyAward() : null;
            }
        }
    },
    methods: {
        addAward() {
            let awards = this.store.formData.awards;
            if (this.currentAward.id) {
                let idx = findIndex(awards, {id: this.currentAward.id});
                if (idx >= 0) {
                    this.$set(awards, idx, this.currentAward);
                }
            }
            else {
                this.currentAward.id = uniqueId('award-');
                awards.push(this.currentAward);
            }
            this.addAwardOpen = false;
        },
        async submitAward() {
            let valid = await this.$refs.addAward.validate();
            if (valid === true) {
                this.addAward();
            }
        },
        deleteAward(award) {
            let index = this.store.formData.awards.indexOf(award);
            if (index >= 0) {
                this.store.formData.awards.splice(index, 1);
            }
        },
        getEmptyAward() {
            return {
                name: '',
                description: '',
                smsTemplate: '',
                availablePerDay: ''
            };
        },
        goToNext({serviceId}) {
            if (this.store.formData.submitType === 'save' || this.isEdit && !this.isEditDraft) {
                return this.goToServiceList();
            }
            let type = this.store.pageType;
            let prefix = this.store.isAdmin ? '' : '/app';
            this.global.redirect({
                url: uri.withQuery(`${prefix}/service/${serviceId}/lottery/award/list`, {formerPageType: type}),
                type: 'push'
            });
        }
    }
});
</script>

<style lang="less">
.lottery-service-form-view {
    .award-item {
        display: block;
        margin: 10px 0 0 0;
        .veui-button {
            margin-left: 10px;
        }
    }
    .veui-form-label {
        min-width: 130px;
    }
    .veui-input-input {
        width: 300px;
    }
}
.add-award-dialog {
    .veui-dialog-content {
        width: 600px;
    }
}
</style>
